import { createAction } from 'redux-actions'
import Api from '../Api'

import { setAlert } from './alerts'
import { SAVE_RIDER } from './rider'

export const ADD_RIDER_ITEM = createAction('ADD_RIDER_ITEM', item => item)
export const REMOVE_RIDER_ITEM = createAction('REMOVE_RIDER_ITEM', item => item)
export const CREATE_RIDER_ITEM = createAction('CREATE_RIDER_ITEM', item => item)
export const CREATE_RIDER_ITEMS = createAction('CREATE_RIDER_ITEMS', item => item)
export const CLONE_RIDER_ITEM = createAction('CLONE_RIDER_ITEM', item => item)
export const EDIT_RIDER_ITEM = createAction('EDIT_RIDER_ITEM', item => item)
export const MOVE_RIDER_ITEM = createAction('MOVE_RIDER_ITEM', item => item)
export const DELETE_RIDER_ITEM = createAction('DELETE_RIDER_ITEM', item => item)
export const DELETE_RIDER_ITEM_GROUP = createAction('DELETE_RIDER_ITEM_GROUP', item => item)

export const addRiderItem = (item) => {
  return (dispatch) => dispatch(ADD_RIDER_ITEM({item}))
}

export const removeRiderItem = (item) => {
  return (dispatch) => dispatch(REMOVE_RIDER_ITEM({item}))
}

export const createRiderItem = (riderId, item) => {
  return (dispatch) => {
    dispatch(SAVE_RIDER())

    return Api.createRiderItem(riderId, item)
      .then(response => dispatch(CREATE_RIDER_ITEM({data: response.data})))
      .catch(error => dispatch(setAlert('Sorry, we were unable to process your request at this time.', undefined, 'error')))
  }
}

export const createRiderItems = (riderId, parent, items) => {
  return (dispatch) => {
    dispatch(SAVE_RIDER())

    return Api.createRiderItems(riderId, parent, items)
      .then(response => dispatch(CREATE_RIDER_ITEMS({data: response.data})))
      .catch(error => dispatch(setAlert('Sorry, we were unable to process your request at this time.', undefined, 'error')))
  }
}

export const cloneRiderItem = (riderId, parent, item) => {
  return (dispatch) => {
    dispatch(SAVE_RIDER())

    return Api.cloneRiderItem(riderId, parent, item)
      .then(response => dispatch(CLONE_RIDER_ITEM({data: response.data})))
      .catch(error => dispatch(setAlert('Sorry, we were unable to process your request at this time.', undefined, 'error')))
  }
}

export const editRiderItem = (riderId, item) => {
  return (dispatch) => {
    dispatch(SAVE_RIDER())

    return Api.editRiderItem(item)
      .then(response => dispatch(EDIT_RIDER_ITEM({data: response.data})))
      .catch(error => dispatch(setAlert('Sorry, we were unable to process your request at this time.', undefined, 'error')))
  }
}

export const moveRiderItem = (id, position) => {
  return (dispatch) => {
    dispatch(SAVE_RIDER())

    return dispatch(MOVE_RIDER_ITEM(Api.moveRiderItem(id, position)))
  }
}

export const deleteRiderItem = (id) => {
  return (dispatch) => {
    dispatch(SAVE_RIDER())

    return dispatch(DELETE_RIDER_ITEM(Api.deleteRiderItem(id)))
  }
}

export const deleteRiderItemGroup = (item) => {
  return (dispatch) => {
    dispatch(SAVE_RIDER())

    const { children } = item

    children.forEach((child, index) => {
      if (child.class === 'monitor') {
        Api.editRiderItem({
          id: child.id,
          value: item.value || null,
          member: (item.member && item.member.id) || null,
          parent: null
        })
        .then(response => {
          dispatch(EDIT_RIDER_ITEM({data: response.data}))

          if (index === children.length-1) dispatch(DELETE_RIDER_ITEM(Api.deleteRiderItem(item.id)))
        })
        .catch(error => dispatch(setAlert('Sorry, we were unable to process your request at this time.', undefined, 'error')))
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/rider-item.js